import { createSlice } from '@reduxjs/toolkit';

const { reducer, actions } = createSlice({
  name: 'chartReport',
  initialState: { items: [] },
  reducers: {
    setItems(state, action) { state.items = action.payload; },
  }
});

export { actions as chartReportActions };
export { reducer as chartReportReducer };
